<template>
    <div style="background-color: #fff; box-sizing: border-box;">
        <div style="display: inline-block; width: 100%;">
            <a-calendar :header-render="headerRender" @panelChange="onPanelChange" @select="onSelect">
                <div slot="dateCellRender" slot-scope="value" class="events">
                   
                    <div v-for="item in getListData(value)" :key="item.content">
                        <a-badge style="font-size: 10px; padding-left: 20px;" :status="item.type" :text="item.content" />
                    </div>
                </div>
            </a-calendar>
        </div>

        <!-- 批量生成日期价格 -->
        <a-modal :title="priceDayTitle" width="100%" :visible="addPriceDayVisible" :confirm-loading="priceDayConfirmLoading" @ok="priceDayHandleOk" @cancel="addPriceDayVisible = false" :maskClosable="false" :keyboard="false" >
            <a-form-model style="" ref="addRuleForm" :model="addForm" :label-col="{span: 4}" :wrapper-col="{span: 14}" >
                <div class="qa-table-item-1" v-for="(item, index) in addForm.weekDayRule" :key="index">
                    <div class="qa-xxgz"  has-feedback >
                        <div class="qa-xxgz-title">{{ getLabel(item.weekDay) }}</div>
                        <div class="qa-xxgz-line" >
                            <a-form-model-item :prop="`weekDayRule[${index}].showName`">
                                <a-input addon-before="价格名称" v-model="item.showName" placeholder="价格名称" style="width: 300px;margin-left: 16px;"/>
                            </a-form-model-item>
                            <a-form-model-item :prop="`weekDayRule[${index}].salePrice`" :rules="[{ required: true, message: '请输入实际售价', trigger: 'blur' }, { pattern: /^\d+(\.\d{1,2})?$/, message: '最多2位小数', trigger: 'blur' }]">
                                <a-input type="number" min="0" addon-before="实际售价" v-model="item.salePrice" placeholder="实际售价" style="width: 300px;margin-left: 16px;"/>
                            </a-form-model-item>
                            <a-form-model-item :prop="`weekDayRule[${index}].settlementPrice`" :rules="[{ required: true, message: '请输入结算价格', trigger: 'blur' }, { pattern: /^\d+(\.\d{1,2})?$/, message: '最多2位小数', trigger: 'blur' }]">
                                <a-input type="number" min="0" addon-before="结算价格" v-model="item.settlementPrice" placeholder="结算价格" style="width: 300px;margin-left: 16px;"/>
                            </a-form-model-item>
                            <a-form-model-item :prop="`weekDayRule[${index}].inventoryTotal`" :rules="[{ required: true, message: '请输入限售数量', trigger: 'blur' }, { pattern: /^\d+$/, message: '请输入正整数', trigger: 'blur' }]">
                                <a-input type="number" min="0" addon-before="限售数量" v-model="item.inventoryTotal" placeholder="限售数量" style="width: 300px;margin-left: 16px;"/>
                            </a-form-model-item>
                        </div>
                    </div>
                </div>
            </a-form-model>
        </a-modal>
        <!-- 编辑日期价格 -->
        <a-modal :title="priceDayTitle" width="40%" :visible="editDayPriceDayVisible" :confirm-loading="priceDayConfirmLoading" @ok="priceDayDetailHandleOk" @cancel="editDayPriceDayVisible = false" :maskClosable="false" :keyboard="false" >
            <a-form-model ref="editDayRuleForm" :model="editDayForm" :label-col="{span: 4}" :wrapper-col="{span: 14}">
                 <div class="qa-table-item-1">
                    <div class="qa-xxgz"  has-feedback >
                        <a-form-model-item label="价格名称" prop="showName" >
                            <a-input v-model="editDayForm.showName" placeholder="价格名称" style="width: 300px;margin-left: 16px;"/>
                        </a-form-model-item>
                    </div>
                </div>
                <div class="qa-table-item-1">
                    <div class="qa-xxgz"  has-feedback >
                        <a-form-model-item label="实际售价" prop="salePrice" :rules="[{ required: true, message: '请输入实际售价', trigger: 'blur' }, { pattern: /^\d+(\.\d{1,2})?$/, message: '最多2位小数', trigger: 'blur' }]">
                            <a-input type="number" min="0" v-model="editDayForm.salePrice" placeholder="实际售价" style="width: 300px;margin-left: 16px;"/>
                        </a-form-model-item>
                    </div>
                </div>
                <div class="qa-table-item-1">
                    <div class="qa-xxgz"  has-feedback >
                        <a-form-model-item label="结算价格" prop="settlementPrice" :rules="[{ required: true, message: '请输入结算价格', trigger: 'blur' }, { pattern: /^\d+(\.\d{1,2})?$/, message: '最多2位小数', trigger: 'blur' }]">
                            <a-input type="number" min="0" v-model="editDayForm.settlementPrice" placeholder="结算价格" style="width: 300px;margin-left: 16px;"/>
                        </a-form-model-item>
                    </div>
                </div>
                <div class="qa-table-item-1">
                    <div class="qa-xxgz"  has-feedback >
                        <a-form-model-item label="限售数量" prop="inventoryTotal" :rules="[{ required: true, message: '请输入限售数量', trigger: 'blur' }, { pattern: /^\d+$/, message: '请输入正整数', trigger: 'blur' }]">
                            <a-input type="number" min="0" v-model="editDayForm.inventoryTotal" placeholder="限售数量" style="width: 300px;margin-left: 16px;"/>
                        </a-form-model-item>
                    </div>
                </div>
            </a-form-model>
        </a-modal>
        <!-- 批量修改日期价格 -->
        <a-modal :title="priceDayTitle" width="100%" :visible="editPriceDayVisible" :confirm-loading="priceDayConfirmLoading" @ok="editPriceDayHandleOk" @cancel="editPriceDayVisible = false" :maskClosable="false" :keyboard="false" >
            <a-form-model style="" ref="editRuleForm" :model="editForm" :label-col="{span: 6}" :wrapper-col="{span: 14}" >
                <div class="qa-table-item-1">
                    <div class="qa-header" has-feedback>
                        <div class="qa-date-pickers">
                            <a-form-model-item label="开始范围" prop="startDate" :rules="[{ required: true, message: '请选择开始日期', trigger: 'change' }]">
                                <a-date-picker v-model="editForm.startDate" :disabled-date="disabledDate" type="date" placeholder="请选择开始日期" style="width: 260px;"/>
                            </a-form-model-item>
                            <a-form-model-item label="结束日期" prop="endDate" :rules="[{ required: true, message: '请选择结束日期', trigger: 'change' }]">
                                <a-date-picker v-model="editForm.endDate" :disabled-date="disabledDate" type="date" placeholder="请选择结束日期" style="width: 260px;"/>
                            </a-form-model-item>
                        </div>
                        <div class="qa-add-button">
                            <a-button type="primary" @click="addWeekDayRule">添加规则</a-button>
                        </div>
                    </div>
                </div>
     
                <div class="qa-table-item-1" v-for="(item, index) in editForm.weekDayRule" :key="index">
                    <div class="qa-rule-row"  has-feedback >
                        <div class="qa-rule-fields">
                            <a-form-model-item label="规则" :prop="`weekDayRule[${index}].weekDay`" :rules="[{ required: true, message: '请选择规则', trigger: 'blur' }]">
                                <a-select v-model="item.weekDay" placeholder="请选择规则" @change="(value) => handleWeekDayChange(index, value)" style="width: 190px;">
                                    <a-select-option v-for="week in weekDayOptions" :key="week.value" :value="week.value" :disabled="isOptionDisabled(week.value, index)">{{ week.label }}</a-select-option>
                                </a-select>
                            </a-form-model-item>
                            <a-form-model-item :prop="`weekDayRule[${index}].showName`">
                                <a-input addon-before="价格名称" v-model="item.showName" placeholder="价格名称" style="width: 260px;"/>
                            </a-form-model-item>
                            <a-form-model-item :prop="`weekDayRule[${index}].salePrice`" :rules="[{ required: true, message: '请输入实际售价', trigger: 'blur' }, { pattern: /^\d+(\.\d{1,2})?$/, message: '最多2位小数', trigger: 'blur' }]">
                                <a-input addon-before="实际售价" type="number" min="0" v-model="item.salePrice" placeholder="实际售价" style="width: 260px;"/>
                            </a-form-model-item>
                            <a-form-model-item :prop="`weekDayRule[${index}].settlementPrice`" :rules="[{ required: true, message: '请输入结算价格', trigger: 'blur' }, { pattern: /^\d+(\.\d{1,2})?$/, message: '最多2位小数', trigger: 'blur' }]">
                                <a-input addon-before="结算价格" type="number" min="0" v-model="item.settlementPrice" placeholder="结算价格" style="width: 260px;"/>
                            </a-form-model-item>
                            <a-form-model-item :prop="`weekDayRule[${index}].inventoryTotal`" :rules="[{ required: true, message: '请输入限售数量', trigger: 'blur' }, { pattern: /^\d+$/, message: '请输入正整数', trigger: 'blur' }]">
                                <a-input addon-before="限售数量" type="number" min="0" v-model="item.inventoryTotal" placeholder="限售数量" style="width: 260px;"/>
                            </a-form-model-item>
                        </div>
                        <div class="qa-delete-button">
                            <a-button type="danger" @click="removeWeekDayRule(index)">删除</a-button>
                        </div>
                    </div>
                </div>
            </a-form-model>
        </a-modal>

    </div>
</template>

<script>
import moment from 'moment'
export default {
    name: 'PriceDay',
    props: {
        priceId: { type: Number, default: 0 },
        startDate: { type: String, default: '' },
        endDate: { type: String, default: '' },
        defaultSalePrice: { type: Number, default: 0 },
        defaultSettlementPrice: { type: Number, default: 0 },
    },
    data() {
        return {
            moment,
            addForm: {
                priceId: this.priceId,
                startDate: this.startDate,
                endDate: this.endDate,
                weekDayRule: []
            },
            addRules: {
                salePrice: [{ required: true, message: '请输入实际售价' }],
                settlementPrice: [{ required: true, message: '请输入结算价格' }],
                inventoryTotal: [{ required: true, message: '请输入限售数量' }],
                // 可根据需要添加验证规则
            },
            addPriceDayVisible: false,
            priceDayConfirmLoading: false,
            priceDayTitle: '批量添加日期价格',
            priceDayData: [], // 存储从服务器获取的日期价格数据
            nowDay: '', // 当前日期
            editForm: {
                priceId: this.priceId,
                dayTime: '',
                weekDayRule: []
            },
            weekDayOptions: [
                { value: 'ALL', label: '所有日期' },
                { value: 'MONDAY', label: '周一' },
                { value: 'TUESDAY', label: '周二' },
                { value: 'WEDNESDAY', label: '周三' },
                { value: 'THURSDAY', label: '周四' },
                { value: 'FRIDAY', label: '周五' },
                { value: 'SATURDAY', label: '周六' },
                { value: 'SUNDAY', label: '周日' },
            ],
            editPriceDayVisible: false,
            editDayForm: {
                priceId: this.priceId,
                showName: '',
                inventoryTotal: 0,
                salePrice: 0,
                settlementPrice: 0
            },

            editDayPriceDayVisible: false,
        }
    },
    created() {
        this.initInventoryRule();
        this.priceDayQueryList();
    },
    methods: {
        initInventoryRule() {
            // 初始化7天的库存规则（周一到周日）
            this.addForm.weekDayRule = [
                {"weekDay": "MONDAY", 'showName': '', 'inventoryTotal': 0, 'salePrice': (this.defaultSalePrice/100).toFixed(2), 'settlementPrice': (this.defaultSettlementPrice/100).toFixed(2) },
                {"weekDay": "TUESDAY", 'showName': '', 'inventoryTotal': 0, 'salePrice': (this.defaultSalePrice/100).toFixed(2), 'settlementPrice': (this.defaultSettlementPrice/100).toFixed(2) },
                {"weekDay": "WEDNESDAY", 'showName': '', 'inventoryTotal': 0, 'salePrice': (this.defaultSalePrice/100).toFixed(2), 'settlementPrice': (this.defaultSettlementPrice/100).toFixed(2) },
                {"weekDay": "THURSDAY", 'showName': '', 'inventoryTotal': 0, 'salePrice': (this.defaultSalePrice/100).toFixed(2), 'settlementPrice': (this.defaultSettlementPrice/100).toFixed(2) },
                {"weekDay": "FRIDAY", 'showName': '', 'inventoryTotal': 0, 'salePrice': (this.defaultSalePrice/100).toFixed(2), 'settlementPrice': (this.defaultSettlementPrice/100).toFixed(2) },
                {"weekDay": "SATURDAY", 'showName': '', 'inventoryTotal': 0, 'salePrice': (this.defaultSalePrice/100).toFixed(2), 'settlementPrice': (this.defaultSettlementPrice/100).toFixed(2) },
                {"weekDay": "SUNDAY", 'showName': '', 'inventoryTotal': 0, 'salePrice': (this.defaultSalePrice/100).toFixed(2), 'settlementPrice': (this.defaultSettlementPrice/100).toFixed(2) },
            ]
        },
        getLabel(weekDay) {
            // 根据索引返回星期标签
            switch (weekDay) {
                case "MONDAY":
                    return '周一';
                case "TUESDAY":
                    return '周二';
                case "WEDNESDAY":
                    return '周三';
                case "THURSDAY":
                    return '周四';
                case "FRIDAY":
                    return '周五';
                case "SATURDAY":
                    return '周六';
                case "SUNDAY":
                    return '周日';
                default:
                    return '';
            }
        },
        resetForm() {
            // 重置表单
            this.$refs.addRuleForm.resetFields()
            this.initInventoryRule()
        },
        
        // 批量生成日价格
        addPriceDay() {
            this.priceDayTitle = '批量添加日期价格,有效期：' + this.startDate + '至' + this.endDate
            this.initInventoryRule();
            this.addPriceDayVisible = true
        },
                priceDayHandleOk() {
            this.$refs.addRuleForm.validate(valid => {
                if(valid){
                    this.priceDayApi()
                }
            })
        },
        // 批量生成日价格
        async priceDayApi(){
            this.priceDayConfirmLoading = true
            let data = {
                priceId: this.addForm.priceId,
                startDate: this.startDate,
                endDate: this.endDate,
                weekDayRule: this.addForm.weekDayRule.map(item => ({
                    weekDay: item.weekDay,
                    showName: item.showName,
                    salePrice: Number(item.salePrice) * 100,
                    settlementPrice: Number(item.settlementPrice) * 100,
                    inventoryTotal: Number(item.inventoryTotal)
                }))
            }

            const {data:res} = await this.$http.post(this.navigation.apiPriceBatchAddPriceDay, data)
            if(res.code === 200){
                this.$message.success('生成成功')
                this.priceDayQueryList(this.nowMonth)
                this.addPriceDayVisible = false
            }
            this.priceDayConfirmLoading = false

        },
        // 批量修改日价格
        editPriceDay() {
            this.priceDayTitle = '批量修改日期价格'
            this.editForm.priceId = this.priceId
            this.editForm.weekDayRule = [{
                weekDay: undefined,
                showName: '',
                salePrice: (this.defaultSalePrice/100).toFixed(2),
                settlementPrice: (this.defaultSettlementPrice/100).toFixed(2),
                inventoryTotal: 0
            }]
            this.editPriceDayVisible = true
        },
        // 限制选择日期范围
        disabledDate(currentDate) {
            const start = this.startDate ? this.moment(this.startDate) : null;
            const end = this.endDate ? this.moment(this.endDate) : null;
                
            // 禁用startDate之前的日期
            if (start && currentDate < start.startOf('day')) {
                return true;
            }
            // 禁用endDate之后的日期
            if (end && currentDate > end.endOf('day')) {
                return true;
            }
            return false;
        },
        // 批量修改日价格确认
        editPriceDayHandleOk(){
            this.$refs.editRuleForm.validate(valid => {
                if(valid){
                    this.editPriceDayApi()
                }
            })
        },
        // 批量修改日价格接口
        async editPriceDayApi(){
            this.priceDayConfirmLoading = true
            let data = {
                priceId: this.editForm.priceId,
                startDate: this.editForm.startDate,
                endDate: this.editForm.endDate,
                weekDayRule: this.editForm.weekDayRule.map(item => ({
                    weekDay: item.weekDay,
                    showName: item.showName,
                    salePrice: Number(item.salePrice) * 100,
                    settlementPrice: Number(item.settlementPrice) * 100,
                    inventoryTotal: Number(item.inventoryTotal)
                }))
            }
            const {data:res} = await this.$http.post(this.navigation.apiPriceBatchEditPriceDay, data)
            if(res.code == 200){
                this.$message.success(res.msg)
                this.priceDayQueryList(this.nowMonth)
                this.editPriceDayVisible = false
            }
            this.priceDayConfirmLoading = false
        },

        // 查询日价格列表
        async priceDayQueryList(now){
            if(!now){
                now = this.moment()
            }
            this.nowMonth = now
            try {
                const { data: res } = await this.$http.post(this.navigation.apiPriceDayQueryList, {
                    priceId: this.priceId,
                    startDate: now.format('YYYY-MM-DD'),
                    endDate: now.format('YYYY-MM-DD')   
                });
                if(res.code == 200) {
                    console.log(res.data)
                    if(this.nowDay == ''){
                        this.nowDay = now.format('YYYY-MM-DD')
                    }
                    this.priceDayData = res.data;
                    // 数据加载完成后，可以触发重新渲染
                    this.$forceUpdate();
                }
            } catch (error) {
                console.error('Error fetching price day data:', error);
            }
        },
        // 获取对应日期的日价格信息
        getListData(value) {
            const dateStr = value.format().substring(0, 10);
            // 从priceDayData中查找对应日期的数据
            const dayData = this.priceDayData.find(item => item.dayTime.substring(0, 10) == dateStr);
            // console.log(this.priceDayData)
            if (dayData) {
                return [
                    {
                        content: `实际售价: ${(dayData.salePrice / 100).toFixed(2)}`,
                        type: 'success'
                    },
                    {
                        content: `结算价格: ${(dayData.settlementPrice / 100).toFixed(2)}`,
                        type: 'error'
                    },
                    {
                        content: `当前库存: ${dayData.inventoryTotal - dayData.useTotal}`,
                        type: 'processing'
                    },
                    // {
                    //     content: `显示名称: ${dayData.showName || ''}`,
                    //     type: 'success'
                    // },
                ];
            }
            return [];
        },
        // 每次切换月份时，都会触发onPanelChange方法
        onPanelChange(value, mode) {
            this.priceDayQueryList(value)
        },
        // 每次点击日期时，都会触发onSelect方法
        // 打开修改日价格弹窗
        onSelect(value){
            if(this.nowDay == value.format('YYYY-MM-DD')){
                const dateStr = value.format().substring(0, 10);
                // 从priceDayData中查找对应日期的数据
                const dayData = this.priceDayData.find(item => item.dayTime.substring(0, 10) == dateStr);
                if(dayData){
                    this.apiPriceDayDetails(dateStr)
                }
            }else{
                this.nowDay = value.format('YYYY-MM-DD')
            }
        },
        // 查询指定日期的日价格详情
        async apiPriceDayDetails(dateStr){
            const {data:res} = await this.$http.post(this.navigation.apiPriceDayDetails, {
                priceId: this.priceId,
                dayTime: dateStr
            })
            if(res.code == 200){
                const editDayForm = {
                    priceDayId:res.data.priceDayId,
                    dayTime:res.data.dayTime,
                    priceId:res.data.priceId,
                    salePrice:(Number(res.data.salePrice) / 100).toFixed(2),
                    settlementPrice:(Number(res.data.settlementPrice) / 100).toFixed(2),
                    inventoryTotal:Number(res.data.inventoryTotal),
                    showName:res.data.showName || '',

                }
                this.editDayForm = editDayForm
                this.priceDayTitle = '修改日期价格：' + editDayForm.dayTime.substring(0, 10)
                this.editDayPriceDayVisible = true
            }
        },
       // 确认修改日价格
        priceDayDetailHandleOk(){
            this.$refs.editDayRuleForm.validate(valid => {
                if(valid){
                    this.editPriceDayDetail()
                }else{
                    this.$message.error('请填写完整信息')
                }
            })
        },
        // 修改日价格
        async editPriceDayDetail(){
            this.editDayForm.salePrice = Number(this.editDayForm.salePrice) * 100
            this.editDayForm.settlementPrice = Number(this.editDayForm.settlementPrice) * 100
            const {data:res} = await this.$http.post(this.navigation.apiPriceDayEdit, this.editDayForm)
            if(res.code == 200){
                this.$message.success('修改成功')
                this.priceDayData.map(item => {
                    if(item.dayTime == this.editDayForm.dayTime){
                        item.salePrice = this.editDayForm.salePrice
                        item.settlementPrice = this.editDayForm.settlementPrice
                        item.inventoryTotal = this.editDayForm.inventoryTotal
                        item.showName = this.editDayForm.showName
                    }
                })
                this.editDayPriceDayVisible = false
            }
        },
        // 自定义日历头部
        headerRender({ value, type, onChange, onTypeChange }) {
            const start = 0;
            const end = 12;
            const monthOptions = [];

            const current = value.clone();
            const localeData = value.localeData();
            const months = [];
            for (let i = 0; i < 12; i++) {
                current.month(i);
                months.push(localeData.monthsShort(current));
            }

            for (let index = start; index < end; index++) {
                monthOptions.push(
                <a-select-option class="month-item" key={`${index}`}>
                    {months[index]}
                </a-select-option>,
                );
            }
            const month = value.month();

            const year = value.year();
            const options = [];
            for (let i = year - 10; i < year + 10; i += 1) {
                options.push(
                <a-select-option key={i} value={i} class="year-item">
                    {i}
                </a-select-option>,
                );
            }
            return (
                <div style={{ padding: '10px' }}>
                    <a-row display="flex" justify="space-between">
                        <a-col span={12}>
                            <a-button type="primary" onClick={() => this.addPriceDay()}>批量生成日期价格</a-button>
                            <a-button type="danger" style={{ marginLeft: '10px' }} onClick={() => this.editPriceDay()}>批量修改日期价格</a-button>
                        </a-col>
                        <a-col span={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <a-select style={{ width: '120px' }}
                            dropdownMatchSelectWidth={false}
                            class="my-year-select"
                            onChange={newYear => {
                            const now = value.clone().year(newYear);
                            onChange(now);
                            this.priceDayQueryList(now);
                            }}
                            value={String(year)}
                        >
                            {options}
                        </a-select>
                        
                        <a-select style={{ width: '120px' }}
                            dropdownMatchSelectWidth={false}
                            value={String(month)}
                            onChange={selectedMonth => {
                            const newValue = value.clone();
                            newValue.month(parseInt(selectedMonth, 10));
                            onChange(newValue);
                            this.priceDayQueryList(newValue);
                            }}
                        >
                            {monthOptions}
                        </a-select>
                        </a-col>
                    </a-row>
                </div>
            );
        },
        addWeekDayRule() {
            if(this.editForm.weekDayRule.length >= 7){
                this.$message.warning('最多只能添加7条规则')
                return
            }
            // 添加规则
            this.editForm.weekDayRule.push({
                weekDay: undefined,
                showName: '',
                salePrice: (this.defaultSalePrice/100).toFixed(2),
                settlementPrice: (this.defaultSettlementPrice/100).toFixed(2),
                inventoryTotal: 0
            })
        },
        removeWeekDayRule(index) {
            // 删除规则
            if (this.editForm.weekDayRule.length > 1) {
                this.editForm.weekDayRule.splice(index, 1)
            } else {
                this.$message.warning('至少保留一条规则')
            }
        },
        isOptionDisabled(optionValue, currentIndex) {
            const rules = this.editForm.weekDayRule;
            
            // 检查是否已有其他规则选择了ALL
            const hasAllRule = rules.some((rule, i) => i !== currentIndex && rule.weekDay === 'ALL');
            if (hasAllRule) {
                // 如果已有ALL规则，只能选择ALL
                return optionValue !== 'ALL';
            }
            
            // 检查是否选择了ALL
            if (optionValue === 'ALL') {
                // 如果选择ALL，检查是否已有其他具体日期规则
                return rules.some((rule, i) => i !== currentIndex && rule.weekDay !== 'ALL');
            }
            
            // 检查是否重复选择了同一日期
            return rules.some((rule, i) => i !== currentIndex && rule.weekDay === optionValue);
        },
        handleWeekDayChange(index, newWeekDay) {
            // 处理星期选择变化，确保互斥性
            const rules = this.editForm.weekDayRule;
            
            // 如果选择了ALL，删除其他所有规则
            if (newWeekDay === 'ALL') {
                this.editForm.weekDayRule = [rules[index]];
                return;
            }
            
            // 所有检查通过，更新星期
            rules[index].weekDay = newWeekDay;
        },
    }
}
</script>

<style scoped>
.qa-header{
    width: 100%;
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    font-weight: bold;
    color: #333;
    display: flex;
    justify-content: space-between;
}
.qa-time{
    width: 120px;
}
.qa-xxgz {
    display: flex;
    align-items: top;
    margin: 0 auto;
}
.qa-xxgz-title {
    height: 40px;
    line-height: 40px;
}



.qa-xxgz-line {
    display: flex;
    align-items: center;
}

.qa-xxgz-line .ant-time-picker {
    width: 110px !important;
   
}

.qa-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}

.qa-date-pickers {
    display: flex;
    align-items: center;
    gap: 20px;
}

.qa-add-button {
    display: flex;
    align-items: center;
    margin-bottom: 24px;
}

.qa-rule-row {
    display: flex;
    justify-content: space-between;
    /* align-items: center; */
    width: 100%;
}

.qa-rule-fields {
    display: flex;
    align-items: center;
    gap: 20px;
    flex: 1;
}

.qa-delete-button {
    margin-top: 4px;
    display: flex;
    align-items: flex-start;
}

</style>